var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingRetail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#booking_retail_svg__clip0_17750_111787)",
    stroke: "#E95832",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 17a4.667 4.667 0 100-9.333A4.667 4.667 0 008 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.473 16.26l-.807 6.073 3.333-2 3.334 2-.807-6.08"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "booking_retail_svg__clip0_17750_111787"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 7)",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/booking_retail.21ae3486.svg";
export { SvgBookingRetail as ReactComponent };